export function DemoBadge({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center text-[10px] font-body font-bold uppercase tracking-wider bg-amber-100 text-amber-700 border border-amber-200 px-1.5 py-0.5 rounded ${className}`}
      title="Sample data for preview"
      data-testid="demo-badge"
    >
      Demo
    </span>
  );
}

export function SampleDataNotice({ className = "" }) {
  return (
    <p className={`font-body text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 ${className}`} data-testid="sample-data-notice">
      Items marked <strong>Demo</strong> are sample data for preview — not real venues, events, or members.
    </p>
  );
}
